
import React, { JSX, useState } from 'react'
import classNames from 'classnames'
import { getInitials } from 'lib/helpers'

const failedPictureUrls = new Set<string>()

const isDefaultPictureUrl = (url: string): boolean => {
  try {
    const host = new URL(url).hostname.toLowerCase()
    return (
      host === 'gravatar.com' ||
      host.endsWith('.gravatar.com') ||
      host.endsWith('.auth0.com')
    )
  } catch {
    return true
  }
}

export const Avatar = ({
  name,
  email,
  picture,
  className
}: {
  name?: string
  email?: string
  picture?: string
  className?: string
}): JSX.Element => {
  const [, setFailed] = useState(false)

  const showsPicture =
    picture !== undefined &&
    picture !== '' &&
    !isDefaultPictureUrl(picture) &&
    !failedPictureUrls.has(picture)

  if (showsPicture) {
    return (
      <img
        src={picture}
        alt={name ?? 'Profile picture'}
        data-testid='avatar-picture'
        referrerPolicy='no-referrer'
        onError={() => {
          failedPictureUrls.add(picture)
          setFailed(true)
        }}
        className={classNames('shrink-0 rounded-full object-cover', className)}
      />
    )
  }

  return (
    <div
      data-testid='avatar-initials'
      className={classNames(
        'flex shrink-0 items-center justify-center rounded-full bg-dm-bg-accent font-semibold text-dm-text-primary',
        className
      )}
    >
      {getInitials(name ?? email)}
    </div>
  )
}
